if ($('header').length) {
  $('.top-navigation-contacts strong').text('Potřebujete poradit?');
  $('.responsive-tools').append($('.top-navigation-contacts'))
  $('.responsive-tools').append($('header#header .header-top .navigation-buttons a[data-target="cart"]').clone());
  $('.header-top').append($('.responsive-tools'))
  $('<span class="close"></span>').appendTo('.login-widget .popup-widget-inner');
  $(document).on("click", ".login-widget .popup-widget-inner .close", function () {
    $('body').removeClass('user-action-visible login-window-visible')
  })
  $(document).on('click', function (event) {
    var clickedElement = $(event.target);
    if (!(clickedElement.closest('.login-widget').length || clickedElement.is('a[data-target="login"]'))) {
      $('body').removeClass('login-window-visible user-action-visible');
    }
  });
  $(document).ready(function () {
    let target = 'cart';
    let timeout;
    const $cartHoverArea = $('a[data-target="cart"]');
    $cartHoverArea.on('mouseenter', function () {
      var show = (target === 'cart' && !$('a[data-target="cart"]').hasClass('full')) ? false : true;
      shoptet.popups.showPopupWindow(target, show);
    });

  });


}


$(function () {
  function timeToMinutes(timeString) {
    var parts = timeString.split(':');
    return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
  }

  var now = new Date();
  var currentMinutes = now.getHours() * 60 + now.getMinutes();

  var startMinutes = timeToMinutes(startWork);
  var stopMinutes = timeToMinutes(stopWork);

  console.log(currentMinutes, startMinutes, stopMinutes);

  var $targets = $('.helpLineContact, .top-navigation-contacts, .needHelp .image, .needHelping .image, .detailNeedHelp .image');

  if (!$targets.length) {
    console.log('Elements not found');
    return;
  }

  if (currentMinutes >= startMinutes && currentMinutes < stopMinutes) {
    $targets.addClass('inWork').removeClass('outWork');
  } else {
    $targets.addClass('outWork').removeClass('inWork');
  }

});